export default [
    {
        name:"my_profile",
        label:"My Profile",
        icon:"la la-user",
        link:"/app/my_profile",
        roles:['ADMIN','CLIENT'],
        children:[]
    },
    {
        name:"settings",
        label:"Settings",
        icon:"la la-cogs",
        link:"/app/settings",
        roles:['ADMIN','CLIENT'],
        children:[]
    },
    {
        name:"logout",
        label:"Logout",
        icon:"la la-sign-out",
        link:"/logout",
        roles:['ADMIN','CLIENT'],
        children:[]
    },
]